/** For some reason, no-shadow rule is triggered here i */
/* eslint-disable-next-line no-shadow */
export enum PlantType {
  Solar = 'solar',
  Wind = 'wind',
  Chp = 'chp',
  Bess = 'bess',
  Unknown = 'unknown',
}
